import axios from 'axios'

const IP_API_URL = '/api/mini-ip/ip/v1/get'

/**
 * 生成随机字符串
 */
function generateRequestId() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
}

/**
 * 获取10位时间戳字符串
 */
function getTimestamp() {
  return Math.floor(Date.now() / 1000).toString()
}

/**
 * 国家码（ISO 3166-1 alpha-2）到区域代码的映射
 * 参考：https://en.wikipedia.org/wiki/ISO_3166-1
 */
const countryCodeToLocaleMap = {
  'VN': 'vi',  // 越南 Vietnam
  'HK': 'hk',  // 香港 Hong Kong
  'TW': 'tw',  // 台湾 Taiwan
  'TH': 'th',  // 泰国 Thailand
  'ID': 'id',  // 印尼 Indonesia
  'SG': 'sg',  // 新加坡 Singapore
  'MY': 'my',  // 马来西亚 Malaysia
  'PH': 'ph'   // 菲律宾 Philippines
}

/**
 * 根据IP检测区域代码
 * @returns {Promise<string|null>} 返回区域代码，失败返回null
 */
export async function detectLocaleByIP() {
  try {
    const params = {
      request_id: generateRequestId(),
      timestamp: getTimestamp()
    }
    // 设置3秒超时
    const response = await axios.get(IP_API_URL, { 
      params,
      timeout: 3000 // 3秒超时
    })
    
    // 检查响应状态
    if (!response.data || response.data.code !== 0) {
      console.error('IP detection API error:', response.data?.msg || 'Unknown error')
      return null
    }
    
    // 解析响应数据
    // data 是一个对象，key 为 IP 地址，value 为 IP 信息
    const data = response.data.data
    if (!data || typeof data !== 'object') {
      return null
    }
    
    // 获取第一个 IP 的信息（通常只有一个）
    const ipAddress = Object.keys(data)[0]
    if (!ipAddress) {
      return null
    }
    
    const ipInfo = data[ipAddress]
    if (!ipInfo || !ipInfo.country_code) {
      return null
    }

    // 根据国家码（ISO 3166-1 alpha-2）获取区域代码
    const countryCode = ipInfo.country_code.toUpperCase()
    const locale = countryCodeToLocaleMap[countryCode]
    
    if (locale) {
      return locale
    }
    
    // 如果国家码不在支持列表中，返回 null，由调用方使用默认区域
    console.warn(`Unsupported country code: ${countryCode}`)
    return null
  } catch (error) {
    // 捕获超时错误或其他网络错误
    if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      console.warn('IP detection timeout (3s)')
    } else {
      console.error('IP detection error:', error)
    }
    return null
  }
}
